<template>
  <!-- email 输入框 -->
  <AutoComplete v-model="currentValue" :data="emailArr" @on-search="emailSearch($event)" placeholder="请输入"></AutoComplete>
</template>

<script>
export default {
  props: {
    value: null,
    disabled: null
  },
  components: {},
  data() {
    return {
      timer: {},
      loading: false,
      emailArr: []
    };
  },
  watch: {},
  computed: {
    currentValue: {
      // 动态计算currentValue的值
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    change(id) {
      this.$emit('change', id);
    },
    // 邮箱搜索
    emailSearch(value) {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        const allEmails = [
          '@qq.com',
          '@sina.com',
          '@126.com',
          '@163.com',
          '@139.com',
          '@189.cn',
          '@sohu.com',
          '@dingtalk.com',
          '@aliyun.com',
          '@hotmail.com',
          '@outlook.com',
          '@yeah.net'
        ];
        if (value && !value.includes('@')) {
          this.emailArr = allEmails.map(text => value + text);
        } else if (value && value.includes('@')) {
          const key = value.substr(value.indexOf('@'));
          this.emailArr = allEmails.filter(text => text.includes(key)).map(text => value + text.replace(key, ''));
        } else {
          this.emailArr = [];
        }
      }, 300);
    }
  }
};
</script>
<style lang="scss"></style>
